<template>
  <select-with-buttons :options="
                ['A', 'K', 'Q', 'J', '10', '9', '8', '7', '6', '5', '4', '3', '2'].map(key => {
            return {value: key, text: key, class: ['scoreButton']};
          })
              " @click="propagateClick"></select-with-buttons>
</template>

<script>
import SelectWithButtons from '../lib/SelectWithButtons';

export default {
  name: 'SelectRank',
  components: {SelectWithButtons},
  props: {},
  methods: {
    propagateClick(clicked) {
      this.$emit('click', clicked);
    }
  }
};
</script>

<style scoped>
>>> .scoreButton {
  background: white;
  border: 1px solid #3396B8;
}
</style>